import { render } from "./CyberRiskCard.vue?vue&type=template&id=0f701ee7&scoped=true"
import script from "./CyberRiskCard.vue?vue&type=script&lang=js"
export * from "./CyberRiskCard.vue?vue&type=script&lang=js"

import "./CyberRiskCard.vue?vue&type=style&index=0&id=0f701ee7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f701ee7"]])

export default __exports__